import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";
import SalesCrmCarousel from "../../components/v4/salesCarousel/salesCrmCarousel";
import DesignCrmCarousel from "../../components/v4/designCarousel/DesignCarousel";

import industryIntegration from "../../images/v4/salesReps/sales.png";
import bussinessSuccessbg from "../../images/v4/salesReps/businessSuccessBg.png";
import salesRepHeroImg from "../../images/v4/salesReps/salesReps.png";
import salesReppageHerobg from "../../images/v4/salesReps/salesReppageHerobg.png";
import salesCrmCarouselbg from "../../images/v4/salesReps/salesCarousel.svg";
import realWorldbg from "../../images/v4/salesReps/realWorld.svg";

import adaptImg1 from "../../images/v4/salesReps/expectCrm/adapt1.svg";
import adaptImg2 from "../../images/v4/salesReps/expectCrm/adapt2.svg";
import adaptImg3 from "../../images/v4/salesReps/expectCrm/adapt3.svg";
import adaptImg4 from "../../images/v4/salesReps/expectCrm/adapt4.svg";
import adaptImg5 from "../../images/v4/salesReps/expectCrm/adapt5.svg";
import adaptImg6 from "../../images/v4/salesReps/expectCrm/adapt6.svg";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/salesReps/topcrm/zoho.png";
import compareItemImg3 from "../../images/v4/salesReps/topcrm/engage.png";
import compareItemImg4 from "../../images/v4/salesReps/topcrm/freshsale.png";
import compareItemImg5 from "../../images/v4/salesReps/topcrm/monday.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import realWorldImage2 from "../../images/v4/salesReps/realworld/education.png";
import realWorldImage3 from "../../images/v4/salesReps/realworld/healthCare.png";
import realWorldImage4 from "../../images/v4/salesReps/realworld/travel.png";
import realWorldImage5 from "../../images/v4/salesReps/realworld/e-commerce.png";
import realWorldBg from "../../images/v4/salesReps/realWorld.svg";

import broadcastImg1 from "../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../images/v4/salesReps/Designfor/broadcast5.png";
import experienceImg1 from "../../images/v4/salesReps/experience/exp1.png";
import experienceImg2 from "../../images/v4/salesReps/experience/exp2.png";
import experienceImg3 from "../../images/v4/salesReps/experience/exp3.png";
import experienceImg4 from "../../images/v4/salesReps/experience/exp4.png";
import experienceImg5 from "../../images/v4/salesReps/experience/exp6.webp";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/client7.png";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";

const useStyles = makeStyles((theme) => ({
  SalesRepSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${salesReppageHerobg})`,
    backgroundColor: "#210538",
    padding: "40px 0 0",
    backgroundPosition: "center",
    borderRadius: "0 0 20px 20px",
    "@media only screen and (max-width: 1440px)": {
      backgroundPosition: "top",
      padding: "60px 0 0 ",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "60px 0 0",
      "& .centerContainer": {
        width: "90%",
        marginTop: "50px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "0",
      "& .centerContainer": {
        width: "95%",
        marginTop: "40px",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px 0 0",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
        gap: "20px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      padding: "0",
      "& .centerContainer": {
        marginTop: "20px",
        gap: "16px",
      },
    },
  },
  salesRepContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "20px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "32px",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .bannerDescription": {},
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      paddingTop: "20%",
      "& img": {
        transform: "translateY(1%)!important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      paddingTop: "0",
      maxWidth: "500px",
      "& img": {
        transform: "translateY(15%)!important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
    "& img": {
      transform: "translateY(18%)",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
        marginBottom: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "100px",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "0px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    marginBottom: "90px",
    color: "#fff",
    "& h2": {
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& h2": {
        paddingRight: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
      marginTop: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      marginTop: "25px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "12px",
      marginTop: "15px",
    },
  },
  customerExperencesBox: {
    width: "32%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "50px",
    background: "#002c51",
    borderRadius: "15px",
    padding: "20px",
    minHeight: "230px",
    backdropFilter: "blur(30px) brightness(0.8)",
    overflow: "hidden",

    "& p:nth-child(2)": {
      color: "#D1E4F1",
    },
    "& p:last-child": {
      color: "#D1E4F1",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "31%",
      gap: "30px",
      padding: "18px",
      minHeight: "200px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "48%",
      gap: "25px",
      padding: "16px",
      minHeight: "180px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      padding: "15px",
      borderRadius: "20px",
      minHeight: "max-content",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      gap: "12px",
    },
    "&.orangeCard1": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard3": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard5": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard7": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard3": {
      background: "rgba(0, 154, 153, 0.4)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard0": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard2": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard4": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard6": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard7": {
      background: "#002C51",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  integrationSection: {
    background: "linear-gradient(90deg, #0A2F4F 9.44%, #2576BB 88.75%)",
  },
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "18px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  combineSection: {
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      marginTop: "40px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      marginTop: "20px",
    },
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
    "& .container": {
      paddingTop: "0",
    },
    "@media only screen and (max-width: 768px)": {
      position: "static",
      transform: "translate(0, 0)",
    },
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "8px",
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",

    "& img": {
      width: "24px",
      height: "24px",
    },

    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      marginTop: "0",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      color: "#1D6FB6",
      gap: "10px",
      "@media only screen and (max-width: 768px)": {
        marginBottom: "15px",
      },
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "0",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
    "& .exp-desc": {
      margin: "10px 0",
    },
  },

  accordianTabs: {
    paddingBottom: "300px",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "250px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "0",
    },

    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "64px",
      gap: "100px",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "40%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "18px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    padding: "15px 0",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  broadcastBox: {
    padding: "32px 32px 0",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",
    gap: "40px",
    "& img": {
      maxWidth: "80%",
      width: "auto",
      height: "auto",
      margin: "0 auto 0",
      display: "table",
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "auto",
      },
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "90%",
        height: "auto",
      },
    },
  },
  designCrmCarousel: {
    backgroundColor: "#e9f4fd",
    "& .designHeader": {
      maxWidth: "55%",
      "& h2": {
        marginBottom: "24px",
      },
      "& p": {
        marginBottom: "16px",
      },
      "@media(max-width:768px)": {
        maxWidth: "100%",
        "& h2": {
          marginBottom: "18px",
        },
        "& p": {
          marginBottom: "15px",
        },
      },
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
      "& .swiper-slide": {
        height: "auto!important",
      },
    },
    "@media(max-width:768px)": {
      "& .swiper-wrapper": {
        padding: "0 24px ",
      },
    },
    ".swiper-slide": {
      width: "100%!important",
    },
  },
  broadcastContainerInner: {
    display: "flex",
    flexDirection: "column-reverse",
    paddingBottom: "86px",
    "@media(max-width:1024px)": {
      padding: "0 50px 32px!important",
    },
    "@media(max-width:600px)": {
      padding: "0 0 32px!important",
    },
    "& .swiper-button-prev": {
      top: "100px !important",
      left: "auto",
      right: "200px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
    "& .swiper-button-next": {
      top: "100px !important",
      right: "100px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
  },
  faqBoxAccordian: {
    padding: "24px",
    backgroundColor: "#f8fcff",
    borderRadius: "16px",
    cursor: "pointer",
    "&.active": {
      backgroundImage: " linear-gradient(89deg, #e0effd 4%, #e0fafa 100%)",
    },
    "@media(max-width:768px)": {
      padding: "16px",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    "&.noClick": {
      cursor: "not-allowed",
    },
    "& h3": {
      margin: "0",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#e9f4fe",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  realWorldTabs: {
    backgroundImage: `url(${realWorldBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "65px 15px",
      "& .container": {
        padding: "0 15px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "40px 15px",
      "& .container": {
        padding: "0",
      },
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "40%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      maxWidth: "500px",
      margin: "0 auto",
    },
  },

  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "8px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },
}));

const experienceList = [
  {
    title: "Organise and convert leads effortlessly",
    alt: "Convert  visitors into leads",
    lintText: "Convert  visitors into leads",
    linkUrl: "https://peppercloud.com/lead-capture-generation-webform/",
    img: experienceImg1,
    desc: "Capture, assign, and manage leads from a single, streamlined dashboard. Automatically track conversations, activities, and lead stages with real-time visibility. Assign leads to the right reps, and move opportunities forward. With smart reminders and a seamless UI, nothing slips through the cracks.",
  },
  {
    title: "Make data-driven sales decisions",
    alt: "Make data-driven sales decisions",
    lintText: "Sales dashboard",
    linkUrl: "https://peppercloud.com/sales-dashboard/",
    img: experienceImg2,
    desc: "Pepper Cloud’s custom dashboards and AI insights help you identify high-value leads and optimise performance. Make faster, smarter decisions based on real-time data. Your team stays proactive instead of reactive.",
  },
  {
    title: "Streamline tasks with sales automation",
    alt: "Streamline tasks with sales automation",
    lintText: "Workflow automation",
    linkUrl: "https://peppercloud.com/sales-crm-features/workflow-automation/",
    img: experienceImg3,
    desc: "Automate repetitive tasks like follow-ups, lead assignment, and activity tracking with Pepper Cloud’s intelligent automation tools. Sales reps receive smart alerts to act at the right time, helping them stay consistent and focused. Boost productivity while reducing manual effort—so your team can focus on converting leads faster.",
  },
  {
    title: "Personalised omnichannel communication",
    alt: "Personalised omnichannel communication",
    lintText: "Multichannel integration",
    linkUrl:
      "https://peppercloud.com/sales-crm-features/multichannel-integration-for-sales-marketing/",
    img: experienceImg4,
    desc: "Connect across messaging, email, and calls all within the CRM. Pepper Cloud helps you tailor communication using templates, custom fields, and engagement history. Build relationships with relevant, timely messages based on lead behaviour. Every interaction feels personal, not robotic.",
  },
  {
    title: "Close leads on the go",
    alt: "Close leads on the go",
    lintText: "Try mobile app",
    linkUrl: "https://peppercloud.com/best-mobile-crm-system-app-ios-android/",
    img: experienceImg5,
    desc: "Access full CRM features from mobile, view leads, send messages, and update pipelines wherever you are. Pepper Cloud ensures your team stays productive while travelling or working remotely. Stay connected to your sales data and prospects, anytime and anywhere. Sell smarter, even outside the office.",
  },
];
const tabs = ["Ecommerce", "Travel and tours", "Healthcare", "Education"];
const tabContentData = [
  {
    tabContent: [
      {
        heading: "Capture leads from ads and forms",
        content:
          "Bring leads from web forms, WhatsApp, and landing pages into one place.",
        alt: "All-in-one CRM",
      },
      {
        heading: "Course-specific messaging",
        content:
          "Send personalised responses based on course interest, education level, or timeline.",
        alt: "Omnichannel CRM",
      },
      {
        heading: "Automated counselling tasks",
        content:
          "Assign follow-ups, book sessions, and reduce manual effort in lead nurturing",
        alt: "Sales management",
      },
      {
        heading: "Track enrolment funnel",
        content:
          "See how many students are active, inactive, or near conversion in real time.",
        alt: "Activity management",
      },
    ],
    image: realWorldImage2,
    alt: "Whatsapp CRM for eCommerce",
    subtitle:
      "From initial enquiries to final enrolments, Pepper Cloud helps sales teams manage conversations, reminders, and pipelines smoothly.",
  },
  {
    tabContent: [
      {
        heading: "Manage appointment leads",
        content:
          "Centralise inbound queries from WhatsApp, calls, and website into one CRM.",
        alt: "Appointment Lead Management",
      },
      {
        heading: "Send WhatsApp notifications",
        content:
          "Confirm bookings, send reminders, and share updates directly with patients.",
        alt: "WhatsApp Notifications",
      },
      {
        heading: "Auto-reminders for consultations",
        content:
          "Reduce no-shows by automating appointment and follow-up reminders.",
        alt: "Consultation Reminders",
      },
      {
        heading: "Segment services and treatments",
        content:
          "Create pipelines based on specialities, treatment types, or service packages.",
        alt: "Service Segmentation",
      },
    ],
    image: realWorldImage3,
    alt: "Whatsapp CRM for Education",
    subtitle:
      "Clinics, labs, and wellness centres use Pepper Cloud to manage follow-ups, appointments, and patient engagement across channels.",
  },
  {
    tabContent: [
      {
        heading: "Organise leads by destination",
        content:
          "Group leads by location, trip type, or travel dates to streamline follow-ups.",
        alt: "Lead Organisation",
      },
      {
        heading: "Send travel catalogues via WhatsApp",
        content:
          "Share pre-built packages, custom quotes, and brochures instantly.",
        alt: "Travel Catalogue Sharing",
      },
      {
        heading: "Automated follow-up messages",
        content:
          "Re-engage cold leads with targeted, timely WhatsApp campaigns.",
        alt: "Follow-up Automation",
      },
      {
        heading: "Monitor bookings and interest levels",
        content:
          "Track lead activity and spot hot prospects through CRM dashboards.",
        alt: "Booking and Interest Tracking",
      },
    ],
    image: realWorldImage4,
    alt: "Whatsapp CRM for Education",
    subtitle:
      "Tour operators and agents use Pepper Cloud to simplify travel bookings, customise responses, and increase sales engagement.",
  },
  {
    tabContent: [
      {
        heading: "WhatsApp and email in one place",
        content:
          "Manage multi-channel conversations from a centralised shared inbox.",
        alt: "Shared Inbox Management",
      },
      {
        heading: "Product-based lead tracking",
        content:
          "View interest levels and conversions by individual product or category.",
        alt: "Product Lead Tracking",
      },
      {
        heading: "Instant restock and offer alerts",
        content:
          "Send automated messages for new launches, restocks, or limited-time discounts.",
        alt: "Automated Offer Alerts",
      },
      {
        heading: "Dashboard for rep and product performance",
        content:
          "Monitor rep activity and sales outcomes for better coaching and strategy.",
        alt: "Sales Performance Dashboard",
      },
    ],
    image: realWorldImage5,
    alt: "Whatsapp CRM for Education",
    subtitle:
      "Retail teams need fast replies, quick turnaround, and smart tracking. Pepper Cloud ensures every lead is responded to without delay.",
  },
];
const SalesReps = () => {
  // client carousel
  const clientScrollData = {
    title: "Trusted by top brands across industries",
    backgroundImage: "",
    logos: [
      {
        img: clientLogo1,
      },
      {
        img: clientLogo2,
      },
      {
        img: clientLogo3,
      },
      {
        img: clientLogo4,
      },
      {
        img: clientLogo5,
      },
      {
        img: clientLogo6,
      },
      {
        img: clientLogo7,
      },
    ],
    directions: ["left", "right", "left"],
    speeds: [0.8, 0.4, 0.8],
  };

  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const tabContainerRef = useRef(null);

  const [activeCompare, setActiveCompare] = useState("#section0");

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const classes = useStyles();

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard3`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard2`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard0`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard4`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard6`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard1`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard5`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard7`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];
  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];
    const logotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
        case 2:
          logotrack3.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
      logotrack3,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 25 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  const benifitList = [
    {
      img: industryIntegration,
      title: "Why do sales reps need CRM software?",
      desc: "Sales reps manage a high volume of interactions and follow-ups. Without a CRM, important tasks often slip through the cracks. A CRM system helps reps stay organised, track progress and nurture leads more effectively. It provides visibility into the sales pipeline, minimises data entry, and increases accountability across the team.",
    },
  ];

  const faqs = [
    {
      question: "What makes Pepper Cloud the best CRM for sales reps?",
      answer: (
        <>
          Pepper Cloud is built for speed and simplicity. It automates manual
          tasks, centralises customer data, and helps reps focus on selling—not
          admin work.
        </>
      ),
    },
    {
      question: "Can I access Pepper Cloud on mobile?",
      answer: (
        <>
          Yes! Pepper Cloud is available on both Android and iOS, so you can
          manage leads, track opportunities, and follow up on the go.
        </>
      ),
    },
    {
      question: "Does Pepper Cloud CRM support team collaboration?",
      answer: (
        <>
          Absolutely. With Pepper Cloud CRM, you can collaborate in real time
          with custom dashboards, share email and message inbox, and more across
          your sales team.
        </>
      ),
    },
    {
      question: "Can I automate sales follow-ups?",
      answer: (
        <>
          Yes, with built-in workflow automation, Pepper Cloud CRM enables sales
          reps to automate follow-ups, stage changes, and sending reminders.
        </>
      ),
    },
    {
      question: "What integrations does Pepper Cloud support?",
      answer: (
        <>
          Pepper Cloud integrates with WhatsApp, Gmail, Outlook, and more—so
          your sales tools work together seamlessly.
        </>
      ),
    },
  ];

  const adaptList = [
    {
      pointer: "Lead and contact management",
      desc: "Sales reps need a unified space to manage leads, contacts and conversations without toggling between apps.",
      img: adaptImg1,
      alt: "Create whatsapp broadcast list",
    },
    {
      pointer: "Multichannel sales communication",
      desc: "A CRM that supports WhatsApp, email, and calls to connect with prospects instantly and maintain context across channels.",
      img: adaptImg2,
      alt: "Create whatsapp broadcast message​",
    },
    {
      pointer: "Automated task workflows",
      desc: "Automate follow-ups, reminders, opportunity updates, and more to reduce manual effort and focus on selling.",
      img: adaptImg3,
      alt: "Create whatsapp broadcast message​",
    },
    {
      pointer: "Real-time performance tracking",
      desc: "Access to live dashboards and actionable insights helps sales reps track their performance and plan better.",
      img: adaptImg4,
      alt: "CRM for Whatsapp broadcast",
    },
    {
      pointer: "Mobile CRM access",
      desc: "On-the-go access ensures reps can update pipelines, make calls, or send follow-ups directly from their mobile device.",
      img: adaptImg5,
      alt: "CRM for Whatsapp broadcast",
    },
    {
      pointer: "User-friendly CRM interface",
      desc: "Easy to use CRM solution that requires minimal training empowers sales representatives to get started and scale quickly.",
      img: adaptImg6,
      alt: "CRM for Whatsapp broadcast",
    },
  ];

  // sales rep contents
  const bannerPoints = [
    "AI-powered sales insights",
    "WhatsApp CRM for real-time communication",
    "Smart sales automation and reminders",
    "Customisable sales pipelines and activity tracking",
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "Zoho CRM",
    "EngageBay CRM",
    "Freshsales CRM ",
    "Monday CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM is a top-rated simple CRM software for small businesses, offering seamless multichannel sales and marketing solutions. As a powerful CRM software for sales and marketing, it helps growing businesses unify customer interactions, automate sales processes, and gain real-time insights all within an intuitive, easy-to-use platform.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Multichannel integration",
          desc: "Manage conversations across email, WhatsApp, social media, and calls, ensuring seamless customer engagement.",
        },
        {
          title: "Sales automation",
          desc: "Automate follow-ups, lead assignments, and tasks to accelerate lead closures.",
        },
        {
          title: "Analytics and reporting",
          desc: "Gain real-time insights with detailed sales and performance reports to drive data-backed decisions.",
        },
        {
          title: "Mobile CRM",
          desc: "Stay connected and manage customer interactions anytime, anywhere with a feature-rich mobile CRM.",
        },
        {
          title: "Customisable workflows",
          desc: "Adapt the CRM to your business processes with flexible and automated workflows.",
        },
        {
          title: "Track and manage sales activities",
          desc: "Schedule events, assign tasks, and monitor follow-ups to keep your sales agents aligned and proactive.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM helps small businesses engage customers across multiple channels while automating lead management.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Email marketing",
          desc: "Run targeted campaigns to nurture leads.",
        },
        {
          title: "Social media integration",
          desc: "Connect with customers on key platforms.",
        },
        {
          title: "Lead management",
          desc: "Capture and track leads effortlessly.",
        },
      ],
    },
    {
      title: "EngageBay CRM",
      desc: " EngageBay CRM offers an all-in-one platform for small businesses to manage customer interactions and marketing campaigns.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Multichannel communication",
          desc: "Connect with customers via email, chat, social media, and calls.",
        },
        {
          title: "Segmentation and targeting",
          desc: "Personalise marketing by segmenting your audience.",
        },
        {
          title: "Lead scoring",
          desc: "Identify and prioritise high-quality leads for better conversions.",
        },
      ],
    },
    {
      title: "Freshsales CRM",
      desc: "Freshsales CRM helps small businesses streamline sales and customer engagement with smart automation.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Multichannel communication",
          desc: "Engage customers via email, phone, chat, and more.",
        },
        {
          title: "Custom sales pipelines",
          desc: "Tailor pipelines to match your sales process.",
        },
        {
          title: "Workflow automation",
          desc: "Automate tasks to improve efficiency and productivity.",
        },
      ],
    },
    {
      title: "Monday CRM ",
      desc: "Monday CRM offers a flexible and intuitive platform for managing customer interactions and sales processes.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Unified platform",
          desc: "Handle all customer interactions from one place for better efficiency.",
        },
        {
          title: "Customisable dashboards",
          desc: "Track key metrics with personalised dashboards.",
        },
        {
          title: "Integration capabilities",
          desc: "Connect with various tools to enhance CRM functionality.",
        },
      ],
    },
  ];
  const broadcastList = [
    {
      pointer: "CRM for sales managers",
      card: {
        pointer: [
          "Track sales performance, coach teams better, and scale revenue with real-time insights and reports.",
        ],
        img: broadcastImg1,
        alt: "Create whatsapp broadcast list",
        backgroundColor: "#f48446",
        backgroundImage: "linear-gradient(to bottom, #f48446, #783ca8)",
      },
    },
    {
      pointer: "CRM for sales development reps",
      card: {
        pointer: [
          "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
        ],
        img: broadcastImg2,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: "#014957",
        backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
      },
    },
    {
      pointer: "CRM for marketing teams",
      card: {
        pointer: [
          "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
        ],
        img: broadcastImg3,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: " #31114b",
        backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8);",
      },
    },
    {
      pointer: "CRM for customer support teams",
      card: {
        pointer: [
          "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
        ],
        img: broadcastImg4,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#2788e7",
        backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
      },
    },
    {
      pointer: "CRM for business owners",
      card: {
        pointer: [
          "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
        ],
        img: broadcastImg5,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#09939a",
        backgroundImage: " linear-gradient(to bottom, #09939a, #783ca8)",
      },
    },
  ];

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <main>
      <SEO
        description={
          "Pepper Cloud is the best CRM for sales reps that offers all must-have features and integrations like AI, automation, omnichannel connectivity, etc, to drive revenue growth"
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="Best crm for sales reps,Sales agents,Best crm for sales teams,best crm software,Crm software for sales and marketing,best sales crm,CRM software for small businesses"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={"Best CRM for sales reps | Pepper Cloud"}
      />

      <section className={classes.SalesRepSection}>
        <div className="container">
          <div className={classes.salesRepContainer}>
            <div className={classes.salesSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Best CRM solution for sales reps
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white bannerDescription"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Manage leads, improve communication, streamline workflows, and
                boost productivity for faster conversions.
              </motion.p>
              <div className={classes.bannerPoint}>
                {bannerPoints.map((point) => (
                  <div className={classes.banerPointItem}>
                    <img src={bannerTick} />
                    <motion.p
                      className="font-wix-regular font-18 font-white"
                      key={`banner-point-${point}`}
                    >
                      {point}
                    </motion.p>
                  </div>
                ))}
              </div>

              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <motion.div
              className={classes.aiSectionRight}
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <LazyImage
                alt={"WhatsApp CRM"}
                source={salesRepHeroImg}
                width={"100%"}
              />
            </motion.div>
          </div>
        </div>
      </section>
      <ClientScroll {...clientScrollData} />

      {benifitList.map((benifit) => (
        <section className={classes.integrationSection}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <div className={classes.integrationLeft}>
                <motion.h2
                  className="font-wix-semibold font-56 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.title}
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 font-white mt20"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.desc}
                </motion.p>
              </div>
              <div className={classes.integrationRight}>
                <motion.img
                  alt={benifit.title}
                  className={classes.integrationRightImage}
                  initial={{ y: 50, opacity: 0 }}
                  src={benifit.img}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.2 }}
                  whileInView={{ y: 0, opacity: 1 }}
                />
              </div>
            </div>
          </div>
        </section>
      ))}

      <SalesCrmCarousel
        backgroundImage={salesCrmCarouselbg}
        slides={adaptList}
        subtitle=" Sales reps rely on a CRM that simplifies their workflow, improves
              sales productivity, and helps them close more leads faster."
        title="Get a CRM tool that works for you"
      />

      <section className={classes.experienceContainer} ref={ref}>
        <section className={classes.accordianTabs}>
          <div className="container">
            <div className="headercenterContainer">
              <motion.h2
                className="font-wix-semibold font-56 text-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Why Pepper Cloud is the best CRM software
              </motion.h2>
              <p className="font-18 font-wix-regular text-black2">
                Pepper Cloud CRM empowers sales reps with the tool they need to
                work smarter, not harder. From intelligent automation to
                WhatsApp integration, every feature is built to simplify the
                sales process. It’s designed to help reps convert faster, stay
                organised, and perform at their peak — wherever they work.
              </p>
            </div>
            <div className={classes.experienceInnerContainer}>
              <div className={classes.experienceContainerLeft}>
                {experienceList.map((faq, index) => (
                  <motion.div
                    key={index}
                    className={clsx(
                      classes.faqBoxAccordian,
                      activeAccordian === index && "active",
                      "text-color2"
                    )}
                    onClick={() => {
                      if (activeAccordian !== index) {
                        setActiveAccordian(index); // only switch if different
                      }
                    }}
                  >
                    <div
                      className={clsx(
                        classes.experienceHeader,
                        activeAccordian === index && "noClick"
                      )}
                    >
                      <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                      <img
                        alt="Arrow"
                        className={clsx(
                          classes.downArrow,
                          activeAccordian === index && "active"
                        )}
                        src={downArrow}
                      />
                    </div>

                    <Collapse
                      className={classes.body}
                      in={activeAccordian === index}
                    >
                      <p className="font-18 font-wix-regular color-black2 exp-desc">
                        {faq.desc}
                      </p>
                      <a
                        className="font-18 font-wix-regular view-more-link"
                        href={faq.linkUrl}
                      >
                        {faq.lintText}{" "}
                        <img alt="Arrow Right" src={arrowRight} />{" "}
                      </a>
                      <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={faq.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    </Collapse>
                  </motion.div>
                ))}
              </div>
              <div className={classes.experienceContainerRight}>
                {experienceList.map(
                  (experience, index) =>
                    index === activeAccordian && (
                      <motion.img
                        initial={{ opacity: 1, y: 20 }}
                        src={experience.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    )
                )}
              </div>
            </div>
          </div>
          <div className={classes.absoulteCard}>
            <TruestedSection background={true} />
          </div>
        </section>
        <section className={classes.realWorldTabs}>
          <div className="container">
            <div className="centerContainer">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Application and use cases of CRM for sales reps
              </motion.h2>
              <div
                className={classes.tabsContainer}
                ref={tabContainerRef}
                style={{
                  display: "flex",
                  overflowX: "auto",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 0 && "active"
                  )}
                  onClick={() => setActiveRealWorld(0)}
                >
                  Education
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 1 && "active"
                  )}
                  onClick={() => setActiveRealWorld(1)}
                >
                  Healthcare
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 3 && "active"
                  )}
                  onClick={() => setActiveRealWorld(3)}
                >
                  Ecommerce
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 2 && "active"
                  )}
                  onClick={() => setActiveRealWorld(2)}
                >
                  Travel and tours
                </div>
              </div>
            </div>

            <div className={classes.tabCard}>
              <div className={classes.tabCardLeftContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <div>
                        <motion.p
                          className="font-wix-regular font-18 color-black2"
                          initial={{ opacity: 0, y: 20 }}
                          transition={{ duration: 0.3 }}
                          whileInView={{ opacity: 1, y: 0 }}
                        >
                          {listItem.subtitle}
                        </motion.p>
                        <div className={classes.benfitListContainer}>
                          {listItem.tabContent.map((item) => (
                            <motion.div
                              className={classes.benfitListItem}
                              initial={{ opacity: 0, y: 20 }}
                              transition={{ duration: 0.3 }}
                              whileInView={{ opacity: 1, y: 0 }}
                            >
                              <LazyImage
                                alt={item.alt}
                                className={classes.benfitIcon}
                                source={bannerTick}
                              />
                              <div className={classes.benfitListItemContent}>
                                <p className="font-wix-semibold font-20 color-black1">
                                  {item.heading}
                                </p>
                                <p className="font-wix-regular font-18 color-black2">
                                  {item.content}
                                </p>
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      </div>
                    )
                )}
              </div>
              <div className={classes.tabCardRightContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <motion.div
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                      >
                        <LazyImage
                          alt={listItem.alt}
                          source={listItem.image}
                          width={"100%"}
                        />
                      </motion.div>
                    )
                )}
              </div>
            </div>
          </div>
        </section>
      </section>

      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccesSection}>
          <div className={classes.bussinessSuccessContainer}>
            <div className={classes.integrationHeaderItem}>
              <div className={classes.integrationContent}>
                <motion.p
                  className="font-wix-semibold font-20 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Features
                </motion.p>
                <motion.h2
                  className="font-wix-semibold font-56 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Tailored for business success
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  The best CRM for sales reps who want to streamline their sales
                  process, stay organised, and win more deals.
                </motion.p>
              </div>
            </div>

            <section className="sales-logo-carousel">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div
                          className="logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {logotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack3.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="header">
          <motion.h2
            className="font-wix-semibold font-56 font-black1"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Top 5 best sales CRM software for sales reps in 2025
          </motion.h2>
        </div>
        <div className={classes.compareSectionContainer}>
          <div className={classes.compareSectionContainerLeftSection}>
            {compareItems.map((item, index) => (
              <div
                className={clsx(
                  classes.compareSectionLeftItem,
                  activeCompare === `#section${index}` && "active"
                )}
                onClick={() => {
                  scrollToSection(`#section${index}`);
                  setActiveCompare(`#section${index}`);
                }}
              >
                <a
                  className={clsx(
                    "font-22 font-wix-medium font-black1",
                    activeCompare === `#section${index}` && "font-wix-semibold"
                  )}
                  href={`#section${index}`}
                >
                  {item}
                </a>
              </div>
            ))}
          </div>
          <div className={classes.compareSectionContainerRightSection}>
            {compareData.map((data, outerIndex) => (
              <div
                className={classes.compareItemContainer}
                id={`#section${outerIndex}`}
              >
                <h3
                  className="font-40 font-wix-semibold font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.title}
                </h3>
                <p
                  className="font-wix-regular font-18 font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.desc}
                </p>
                <img alt={data.alt} className="productImage" src={data.img} />
                <div className={classes.faqsContainer}>
                  {data.features.map((faq, innerIndex) => (
                    <motion.div
                      className={classes.faqBox}
                      onClick={() =>
                        setActiveAccordian(
                          `${outerIndex}-${innerIndex}` === activeAccordian
                            ? -1
                            : `${outerIndex}-${innerIndex}`
                        )
                      }
                      transition={{ duration: 1, delay: innerIndex * 0.01 }}
                      whileInView={{ opacity: [0, 1], y: [50, 0] }}
                    >
                      <div className={classes.topFiveHeader}>
                        <h3 className="font-20 font-wix-semibold">
                          {faq.title}
                        </h3>
                        <img
                          alt="Arrow"
                          className={clsx(
                            classes.downArrow,
                            `${outerIndex}-${innerIndex}` === activeAccordian &&
                            "active"
                          )}
                          src={downArrow}
                        />
                      </div>
                      <Collapse
                        className={classes.body}
                        in={activeAccordian === `${outerIndex}-${innerIndex}`}
                      >
                        <p className="font-18 font-wix-regular color-black2">
                          {faq.desc}
                        </p>
                      </Collapse>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          faqs={faqs}
          heading={"Best crm for sales reps - Frequently Asked Questions"}
        />
      </div>
      <DesignCrmCarousel backgroundImage={""} bgColor={"#e9f4fd"} />
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Are you looking for the best CRM for sales teams?
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SalesReps;
